import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import {setWageLoading} from './LoadingReducer';

export const setWageList = createAction('SET_WAGE_LIST');
export const loadWageList = (action = {}) => (dispatch, getState) => {
  const {partID, carSize, carType} = action;

  dispatch(setWageLoading({loading: true}));
  axios.get(`/damage/wage_item/${partID}/${carSize}/${carType}?format=json`).
      then((response) => {
        const data = response.data && response.data.data
                     && response.data.data.list || [];
        dispatch(setWageList({
          data: data,
          payload: action,
        }));
        dispatch(setWageLoading({loading: false}));
      }).
      catch((error) => {
        console.error(error);
      });
};

export const WageListReducer = (defaultState) => handleActions({
  loadWageList,
  [setWageList](state, action = {}) {
    const {data, payload} = action.payload || {};
    return data || [];
  },
}, defaultState);

export default WageListReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/WageReducer.js